module.exports = __webpack_public_path__ + "img/github.958cc70f.svg";